import React from "react";

export default function NewFile(props) {
  return (
    <svg viewBox="0 0 6.002 6.002" enableBackground="new 0 0 6.002 6.002">
      <path
        fill={props.color}
        d="m2.401,6.002v-4.56l2.052,.002 1.305,1.305 .003,3.253h-3.36v-8.88178e-16zm1.92-3.952v0.831h0.831l-.831-.831zm.96,1.311h-1.44v-1.44h-0.96v3.6h2.4v-2.16zm-4.562-.102l.86-.859 .344,.343-.859,.86-.345-.344zm0-2.916l.344-.343 .859,.859-.343,.344-.86-.86v5.55112e-17zm.722,1.578h-1.2v-0.48h1.2v0.48z"
      />
    </svg>
  );
}
